import * as React from "react";
import { useState, useContext, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import loginStyles from "./loginStyles.module.css";
import TextField from "@mui/material/TextField";
import ib_logo from "../../icons/IB_logo.png";
import ib_logo1 from "../../icons/ABIS_logo.png";
import {
  Divider,
  Typography,
  Snackbar,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import InputAdornment from "@mui/material/InputAdornment";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import { LoginContext } from "./LoginContext";
import axios from "axios";
import { AUTH_API, GET_AUTH_TOKEN ,PUSH_NOTIFICATION_SAVE_FCM_TOKEN} from "../../constants";
import { connect } from "react-redux";
import { loginSuccess, loginFailure } from "../../Actions/LoginAction";
import { VisibilityOffOutlined } from "@mui/icons-material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { SessionContext } from "../../SessionContext";
import { useTheme } from "@emotion/react";
import MobileLoginPage from "./MobileLoginPage";
// import { requestNotificationPermission } from "../../firebase/notification";
import {updateTokenInBackend} from '../../Utils/fcm';
import { getFCMToken } from "../../Utils/fcm"; // assuming you wrote a helper
import Cookies from "js-cookie";
import {requestFCMToken} from '../../firebase/firebaseUtils';
import { onMessage, getMessaging } from "firebase/messaging";
// import {
//   requestNotificationPermission,
//   setupForegroundNotifications,
// } from "../../services/notification-service";

const LoginComponent = ({
  onLogin,
  isAuthenticated,
  error,
  loginSuccess,
  loginFailure,
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const { login, isLoggedIn, logout } = useContext(LoginContext);

  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobileOrPhablet = useMediaQuery("(max-width: 1080px)");

  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    console.log("handleLogin function called");
    setLoading(true);

    const requestBody = {
      EmployeeId: username,
      EmployeePassword: password,
    };

    try {
      console.log("Sending login request to API...");
      const response = await axios.post(AUTH_API, requestBody);
      console.log("Received API response:", response);

      console.log("Response Status:", response.data.status);
      if (response.data.status == "200") {
        const { employee } = response.data;
   

        // Detect if the app is running as PWA
        const isPWA =
          window.matchMedia("(display-mode: standalone)").matches ||
          (window.navigator.standalone &&
            window.location.hostname !== "localhost") ||
          document.referrer.includes("android-app://");

        // Detect if the device is a Desktop/Laptop
        const isDesktop = window.innerWidth > 1024; // Consider screens > 1024px as desktops

        // If BDMs (role 2 or 3) try to log in from a desktop, block them
        // if (
        //   (employee.EmployeeRole == 2 || employee.EmployeeRole == 3) &&
        //   isDesktop &&
        //   !isPWA
        // ) {
        //   navigate("/pwa-restricted");
        //   setLoading(false);
        //   return; // Stop execution
        // }

        login(response.data.employee.EmployeeRole, response.data.employee);
        loginSuccess(employee);
        localStorage.setItem("username", username);
        localStorage.setItem("password", password);
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("empRole", response.data.employee.EmployeeRole);
        localStorage.setItem("sessionActive", "true"); // Persist state
  

        // console.log("userIdForFCM----",employee.EmployeeId)
        // console.log("employeeeeeeeeeeeeeeeee",employee)

        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 1); // Set expiration to 1 day later

        Cookies.set("userData", JSON.stringify(response.data.employee), {
          expires: 1, // 1 day expiration
          path: "/", // Available throughout the site
          secure: true, // Ensures the cookie is sent over HTTPS
          sameSite: "Strict", // Prevents CSRF attacks
        });

        Cookies.set("authToken", response.data.token, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("username", username, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("passowrd", password, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("empRole", employee.EmployeeRole, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        setSeverity("success");
        setMessage("Login Successful!!");
        setOpenSnackbar(true);

        // Fetch the additional AuthToken
        await fetchAuthToken();

        // requestNotificationPermission();

        // push notification --------------> 26-aug-25

        try {
      const fcmToken = await getFCMToken(employee.EmployeeId); // fetch token from Firebase
     if (fcmToken) {
      await axios.post(PUSH_NOTIFICATION_SAVE_FCM_TOKEN, {
      userId: employee.EmployeeId,
      token: fcmToken,
    });
        console.log("FCM token stored successfully");
        // console.log("FCM token stored successfully",fcmToken);
      } else {
       console.log("No FCM token retrieved");
      }
       } catch (err) {
           console.error("Error saving FCM token:", err);
    }




        // Initialize Firebase notifications after successful login

        // try {
        //   // Request permission and get token
        //   await requestNotificationPermission();

        //   // Set up handlers for foreground notifications
        //   setupForegroundNotifications();

        //   console.log("Notification setup complete");
        // } catch (notificationError) {
        //   console.error("Error setting up notifications:", notificationError);
        //   // Don't block login flow if notifications fail
        // }

        // Navigate to appropriate page based on role
        if (response.data.employee.EmployeeRole == 6) {
          navigate("/estimateGeneration");
        } else if (response.data.employee.EmployeeRole == 2 || response.data.employee.EmployeeRole == 3) {
          if (isDesktop && !isPWA) {
            // Redirect BDM to Dashboard if they are on a Desktop/Laptop and not in PWA mode
            navigate("/dashboard");
          } else if (!response?.data?.employee?.todayAttendance) {
            // If in PWA mode or on a mobile device and attendance is null, go to bdmTask
            navigate("/bdmtask");
          } else {
            // If in PWA mode or on mobile, go to bdmTodo
            navigate("/bdmtodo");
          }
        } else if(response.data.employee.EmployeeRole === 7){
          navigate('/hrReport');
        } else {
          navigate("/dashboard");
        }
      }else {
        // handle invalid credentials or other server messages
        setSeverity("error");
        setMessage(response.data.message || "Login failed");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        loginFailure("Invalid username or password.");
        setSeverity("error");
        setMessage(error.response.data.message);
        setOpenSnackbar(true);
      } else if (error.request) {
        console.log("Request:", error.request);
        setSeverity("error");
        setMessage("Internal Server Error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false); // Re-enable button and hide loader
    }
  };

  // CORS Proxy URL (for development/testing only)
  const corsProxyUrl = "https://cors-anywhere.herokuapp.com/";

  const fetchAuthToken = () => {
    const requestBody = {
      username: "ABIS123",
      password: "ABIS@123",
    };

    axios
      .post(GET_AUTH_TOKEN)
      .then((response) => {
        console.log("AuthToken retrieved:", response.data.token);
        localStorage.setItem("clickToCallToken", response.data.token.idToken); // Save the idToken in local storage
      })
      .catch((error) => {
        console.error("Error fetching AuthToken:", error);
      });
  };

  const logOuT = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {isMobileOrPhablet ? (
        <MobileLoginPage></MobileLoginPage>
      ) : (
        <>
          <div
            className={`h-screen ${loginStyles.background_color} place-content-center`}
          >
            <div className={`flex place-content-center`}>
              <Stack spacing={3} direction="row">
                {/* <div className={`place-content-center w-auto hidden sm:block`}>
            <img
                src={group}
                loading="lazy"
                alt='onCall'
                className={`w-auto h-72`}
            />
            </div> */}
                <Card
                  className={`w-auto`}
                  sx={{ "& .MuiPaper-root": { borderRadius: 0 } }}
                >
                  <CardContent>
                    <Stack
                      spacing={3}
                      direction="column"
                      className={`py-4 px-4`}
                    >
                      <div className={`flex place-content-center h-16 w-auto`}>
                        <img
                          src={ib_logo}
                          loading="lazy"
                          alt="onCall"
                          className={`w-16`}
                        />
                        <Divider
                          orientation="vertical"
                          variant="middle"
                          className={`px-2 ${loginStyles.logo_divider}`}
                          flexItem
                        />
                        <img
                          src={ib_logo1}
                          loading="lazy"
                          alt="onCall"
                          className={`w-28 px-2 ${loginStyles.icon_height}`}
                        />
                      </div>

                      <Typography variant="h5" className={`text-center`}>
                        {" "}
                        Welcome to CRM
                      </Typography>
                      <TextField
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        variant="filled"
                        size="small"
                        className={`w-auto`}
                        sx={{
                          "& .MuiInputBase-root": {
                            borderRadius: 0,
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={`-ml-1`}
                            >
                              <PersonIcon
                                className={`${loginStyles.icon_size}`}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <TextField
                        label="Password"
                        id="filled-size-normal"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        variant="filled"
                        size="small"
                        className={`w-auto`}
                        sx={{
                          "& .MuiInputBase-root": {
                            borderRadius: 0,
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={`-ml-1`}
                            >
                              <LockIcon
                                className={`${loginStyles.icon_size}`}
                              />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end" className={`-ml-1`}>
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      {/* <Link
                        className={`text-end`}
                        variant="caption"
                        style={{ marginTop: "12px" }}
                      >
                        Forgot Password
                      </Link> */}

                      <Button
                        variant="contained"
                        className={`w-auto ${loginStyles.login_button}`}
                        onClick={handleLogin}
                        disabled={loading}
                        sx={{
                          "& .MuiButtonBase-root": {
                            borderRadius: 0,
                          },
                        }}
                      >
                        {loading ? (
                          <>
                            <CircularProgress size={24} color="inherit" />{" "}
                            &nbsp; Processing...
                          </>
                        ) : (
                          "Login"
                        )}
                      </Button>

                      <Snackbar
                        open={openSnackbar}
                        autoHideDuration={6000} // Snackbar will auto hide after 6 seconds
                        onClose={handleCloseSnackbar}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <Alert
                          onClose={handleCloseSnackbar}
                          severity={severity}
                          sx={{ width: "100%" }}
                        >
                          {message}
                        </Alert>
                      </Snackbar>
                    </Stack>
                  </CardContent>
                </Card>
              </Stack>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
});

const mapDispatchToProps = {
  loginSuccess,
  loginFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
